<template>
  <div style="display: inline">

    <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
      placeholder="Pls input tag" size="mini" @change="handleInputConfirm" @blur="inputVisible = false"></el-input>
    <!-- @keyup.enter.native="handleInputConfirm"
      @blur="localtag" -->
    <el-button v-else type="text" @click="showInput">&#9734;</el-button>
  </div>
</template>
<style></style>

<script>
export default {
  data() {
    return {

      inputVisible: false,
      inputValue: ""
    };
  },

  computed: {

  },
  methods: {


    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    localtag() {
      if (this.inputValue) {
        this.$store.commit("addsavedsearch", this.inputValue);
      }

      this.inputVisible = false;
      this.inputValue = "";
    },

    remotetag() {
      this.$prompt('请输入验证码', 'Tip', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      }).then(({ value }) => {

        let fullhref = window.location.href
        let href = fullhref.substring(fullhref.lastIndexOf("##") - 1)

        let tagobj = {
          tag: this.inputValue,
          href: href
        }
        let thedata = {
          collection: this.$store.state.collection.value,
          downloadcode: value,
          tagobj: tagobj
        }

        this.$axios
          .post(url + "remotetag", thedata)
          .then((res) => {
            if (res.data == "wrong") {
              this.$message("验证码错误");
              return;
            }
            else {

              window.location.reload()
            }
          });
        this.inputVisible = false;
        this.inputValue = "";
      })
        .catch(() => {
          this.inputVisible = false;
          this.inputValue = "";
        });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.$confirm('是否创建本地标签Local or Remote', '提示', {
          confirmButtonText: 'Local',
          cancelButtonText: 'Remote',
          distinguishCancelAndClose: true,
          type: 'info',
          callback: action => {
            if (action == "confirm") {
              this.localtag()
            }
            if (action == "cancel") {
              this.remotetag()
            }
            else {
              this.inputVisible = false;
              this.inputValue = "";
            }
          }
        })
        // .then((x) => {
        //   this.localtag()
        // })
        // .catch((x) => {
        //   this.remotetag()
        // });



      }
      else {
        this.inputVisible = false;
        this.inputValue = "";
      }

    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/savesearch.vue